import type { Coverage } from "@adlywise/shared";
import type { DeviceAggregateRow, DeviceListRow } from "./types";

// The device answers as the page uses them; each keeps the `coverage` of its
// read (uncovered ranges = incomplete counts and rows, never a proven zero —
// Codex confirmation review 6).

export const deviceCountOf = (
  response: {
    totalDevices?: number | undefined;
    coverage?: Coverage | undefined;
  } | null,
): { totalDevices: number; coverage: Coverage | null } => ({
  totalDevices: response?.totalDevices ?? 0,
  coverage: response?.coverage ?? null,
});

export const deviceListOf = (
  response: {
    rows?: DeviceListRow[] | undefined;
    coverage?: Coverage | undefined;
  } | null,
): { rows: DeviceListRow[]; coverage: Coverage | null } => ({
  rows: response && Array.isArray(response.rows) ? response.rows : [],
  coverage: response?.coverage ?? null,
});

export const deviceAggregatesOf = (
  response: {
    rows?: DeviceAggregateRow[] | undefined;
    coverage?: Coverage | undefined;
  } | null,
): {
  aggregates: Record<string, DeviceAggregateRow>;
  coverage: Coverage | null;
} => {
  const aggregates: Record<string, DeviceAggregateRow> = {};
  for (const row of response?.rows ?? []) aggregates[row.deviceId] = row;
  return { aggregates, coverage: response?.coverage ?? null };
};
